import './Settings.css'
import { useState, useEffect, ReactNode } from 'react'
import { Form, Button, Dropdown } from "react-bootstrap";
import QrCodeScannerModal from "./modal/qrCodeScannerModal/qrCodeScannerModal";
import ConsoleNavMenu from './console/ConsoleNavMenu';
import { SettingsInsertModemRequestData } from '../api/Settings';
import { APIRequestPost } from '../utils/APIRequests';

function Settings(): ReactNode {
    const [errorInfo, setErrorInfo] = useState<ReactNode>(<div></div>);
    const [isQrCodeScannerModalOpen, setQrCodeScannerModalOpen] = useState<boolean>(false);
    const [codeValue, setCodeValue] = useState<string>('');
    const [version, setVersion] = useState<string>('Version');

    const onChangeCodeInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
        event.preventDefault();
        setCodeValue(event.target.value);
    };

    const onScanQrCodeClick = (): void => {
        setQrCodeScannerModalOpen(true);
    }

    const onDecode = (decodedText: string): void => {
        const tokens = decodedText.match("IMEI:([0-9]*)");
        if (!tokens || tokens.length < 2 || !tokens[1]) {
            console.warn("Failed to parse tokens", tokens);
            return;
        }
        setCodeValue(tokens[1]);
        setQrCodeScannerModalOpen(false);
    }

    useEffect(() => {
        console.log("settings mount");
        return () => {
            console.log("settings unmount");
        };
    }, []);

    function submitFormCreateImeiModem(event: React.FormEvent<HTMLFormElement>): void {
        event.preventDefault();

        const data: SettingsInsertModemRequestData = {
            imei: codeValue,
            version: Number(version)
        };

        APIRequestPost(`/settings/insertModem`, {
            data: data,
            logSuccess: true
        }).then(() => {
            setErrorInfo(<div style={{ color: "red", paddingTop: "10px" }}>imei: {codeValue} добавлен</div>);
        }).catch(() => {
            setErrorInfo(<div style={{ color: "red", paddingTop: "10px" }}>Ошибка добавления</div>);
        });
    }

    return (
        <>
            <ConsoleNavMenu />
            <div className='max-width text-page-padding'>
                <h2>Create imei:</h2>
                <Form onSubmit={submitFormCreateImeiModem} className='create-imei-form'>
                    <Form.Control type="text"
                        placeholder="IMEI"
                        value={codeValue}
                        onChange={onChangeCodeInput}
                    />
                    <br />
                    <Button variant="secondary" onClick={onScanQrCodeClick}>
                        Scan QR-Code
                    </Button>
                    <br />
                    <br />
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            {version}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => setVersion('1004')}>Telemetry 1004</Dropdown.Item>
                            <Dropdown.Item onClick={() => setVersion('1005')}>Telem Rus 1005</Dropdown.Item>
                            <Dropdown.Item onClick={() => setVersion('2001')}>EYE (2001)</Dropdown.Item>
                            <Dropdown.Item onClick={() => setVersion('2002')}>EYE webRtc (2002)</Dropdown.Item>
                            <Dropdown.Item onClick={() => setVersion('2011')}>EYE2 (2011)</Dropdown.Item>
                            <Dropdown.Item onClick={() => setVersion('3001')}>Astra (3001)</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <br />
                    <Button variant="primary" type="submit">
                        Insert
                    </Button>
                </Form>
                {errorInfo}
            </div>
            <QrCodeScannerModal
                show={isQrCodeScannerModalOpen}
                onDecode={onDecode}
                onClose={() => setQrCodeScannerModalOpen(false)}
            />
        </>
    )
}

export default Settings;